import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button, Table, Form, Col, Card } from 'react-bootstrap';
import Headers from '../../components/Headers/Headers';
import { NotifyModal } from '../../components/NotifyModal/NotifyModal';
import Page from '../../components/Page/Page';
import Reload from '../../components/reload/reload';
import ApiMServer from '../../services/ApiMServer';

import decodeJwt from '../../hooks/decode';

const DEFAULT_PERMISSION_SGU = {
  home: { read: false, write: false },
  equipments: { read: false, write: false },
  units: { read: false, write: false },
  report: { read: false, write: false },
  settings: { read: false, write: false },
  silosbag: { read: false, write: false },
  dryer: { read: false, write: false },
  sementeira: { read: false, write: false },
  rodizio: { read: false, write: false },
  alarm: { read: false, write: false },
  companyData: { read: false, write: false },
};

const PERMISSION_SGU_LABELS = {
  home: 'Home',
  equipments: 'Equipamentos',
  units: 'Unidades',
  report: 'Relatório',
  settings: 'Configurações',
  silosbag: 'Silos Bag',
  dryer: 'Secador',
  sementeira: 'Sementeira',
  rodizio: 'Rodízio',
  alarm: 'Alarmes',
  companyData: 'Dados da Empresa',
};

const PERMISSION_SGU_ORDER = [
  'home',
  'units',
  'equipments',
  'report',
  'settings',
  'alarm',
  'rodizio',
  'silosbag',
  'dryer',
  'sementeira',
  'companyData',
];

const HIDDEN_PERMISSION_SGU_KEYS = new Set([
  'home',
  'restricted',
  'restrito',
  'sementeira',
  'mercadofinanceiro',
  'financialmarket',
  'market',
  'financeiro',
  'support',
  'suporte',
  'supportuser',
]);

const UnitsMembersEdit = () => {

  const navigate = useNavigate();

  const { id } = useParams();

  const { _id } = JSON.parse(localStorage.getItem('user'));

  const userDecoded = decodeJwt();
  const { permissionSGU } = userDecoded;
  if (permissionSGU?.units?.write !== true) {
    navigate("/home");
  }

  const [type, setType] = useState({ color: "", status: "" });
  const [modalShow, setModalShow] = useState(false);

  const handleAlertModalSuccess = (msg) => {
    setType({ "color": "#198754", "status": msg });
    setModalShow(true);
  }

  const handleAlertModalError = (msg) => {
    setType({ "color": "red", "status": msg });
    setModalShow(true);
  }

  const [user, setUser] = useState({
    equipments: [],
    _id: '',
    name: '',
    username: '',
    email: '',
    birth: '',
    password: '',
    master: '',
    permissionSGU: DEFAULT_PERMISSION_SGU,
    permission: {
      home: {
        read: false,
        write: false
      },
      users: {
        read: false,
        write: false
      },
      units: {
        read: false,
        write: false
      },
      cooperatives: {
        read: false,
        write: false
      },
      equipments: {
        read: false,
        write: false
      },
      maps: {
        read: false,
        write: false
      },
      charts: {
        read: false,
        write: false
      },
      support: {
        read: false,
        write: false
      },
      supportdry: {
        read: false,
        write: false
      },
      equipmentsQL: {
        read: false,
        write: false
      },
      notifications: {
        read: false,
        write: false
      },
      userspassword: {
        read: false,
        write: false
      },
      general: {
        read: false,
        write: false
      }
    },
    fone: '',
    company: '',
    cpfcnpj: '',
    validationHash: '',
    createdAt: '',
    updatedAt: '',
    __v: 0,
    token: '',
    firebaseToken: '',
    validationEmail: false,
    oldName: null,
    blocked: null
  });

  const defaultState = {
    equipments: [],
    _id: '',
    name: '',
    username: '',
    email: '',
    birth: '',
    password: '',
    master: '',
    permissionSGU: DEFAULT_PERMISSION_SGU,
    permission: {
      home: { read: false, write: false },
      users: { read: false, write: false },
      units: { read: false, write: false },
      cooperatives: { read: false, write: false },
      equipments: { read: false, write: false },
      maps: { read: false, write: false },
      charts: { read: false, write: false },
      support: { read: false, write: false },
      supportdry: { read: false, write: false },
      equipmentsQL: { read: false, write: false },
      notifications: { read: false, write: false },
      userspassword: { read: false, write: false },
      general: { read: false, write: false },
    },
    fone: '',
    company: '',
    cpfcnpj: '',
    validationHash: '',
    createdAt: '',
    updatedAt: '',
    __v: 0,
    token: '',
    firebaseToken: '',
    validationEmail: false,
    oldName: null,
    blocked: null,
  };

  const [loading, setLoading] = useState(true);

  const handleUserDetail = async () => {
    setLoading(true);
    try {
      const { data } = await ApiMServer.get(`/users/${id}`);
      const apiResponse = data;
      setUser((prevState) => ({
        ...defaultState,
        ...prevState,
        ...apiResponse,
        permissionSGU: {
          ...defaultState.permissionSGU,
          ...prevState.permissionSGU,
          ...apiResponse.permissionSGU,
        },
        permission: {
          ...defaultState.permission,
          ...prevState.permission,
          ...apiResponse.permission,
        },
      }));
    } catch (e) {
      alert("Erro ao carregar!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleUserDetail();
  }, [id]);

  const getPermissionLabel = (key) => {
    if (PERMISSION_SGU_LABELS[key]) return PERMISSION_SGU_LABELS[key];
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (char) => char.toUpperCase());
  };

  const isHiddenPermissionKey = (key) => {
    const normalizedKey = String(key).replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
    return HIDDEN_PERMISSION_SGU_KEYS.has(normalizedKey);
  };

  const handlePermissionChange = (permissionKey, action, checked) => {
    setUser((prevState) => ({
      ...prevState,
      permissionSGU: {
        ...prevState.permissionSGU,
        [permissionKey]: {
          ...prevState.permissionSGU?.[permissionKey],
          [action]: checked,
        },
      },
    }));
  };

  const permissionRows = [
    ...PERMISSION_SGU_ORDER.filter((key) => user?.permissionSGU?.[key]),
    ...Object.keys(user?.permissionSGU || {}).filter((key) => !PERMISSION_SGU_ORDER.includes(key)),
  ].filter((key, index, array) => {
    const permission = user?.permissionSGU?.[key];
    return array.indexOf(key) === index
      && !isHiddenPermissionKey(key)
      && (permission?.read !== undefined || permission?.write !== undefined);
  });

  const saveUser = async () => {
    try {
      user.userId = _id;
      const { data } = await ApiMServer.put('/user', user);
      setUser(data);
      handleAlertModalSuccess('Atualizado com sucesso!');
    } catch (error) {
      if (error?.response?.data?.status) {
        handleAlertModalError(error?.response?.data?.status);
      } else {
        handleAlertModalError("Erro ao atualizar, faça login novamente!");
      }
    }
  };

  return (
    <Page title={"Editar Membros"}>
      <Headers page="Editar Membros" />

      {loading && <Reload />}

      <NotifyModal
        type={type}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      <Card className='mt-2'>
        <Card.Header>Páginas que o usuário <b>{user?.name ? user?.name : user?.email}</b> pode Ver ou Editar</Card.Header>
        <Card.Body>

          <Col md>
            <h4 className='text-center'>Autorizações Site SGU</h4>
            <Table style={{ fontSize: "0.9rem" }} striped bordered hover responsive size='sm'>
              <thead>
                <tr className="table-secondary text-center">
                  <th className='col-sm-6'>Página</th>
                  <th className='col-sm-3'>Ver</th>
                  <th className='col-sm-3'>Editar</th>
                </tr>
              </thead>
              <tbody>

                {permissionRows.map((permissionKey) => (
                  <tr className='text-center' key={permissionKey}>
                    <td>
                      {getPermissionLabel(permissionKey)}
                    </td>
                    <td>
                      <Form.Check type="checkbox">
                        <Form.Check.Input
                          type="checkbox"
                          checked={!!user?.permissionSGU?.[permissionKey]?.read}
                          onChange={(event) => handlePermissionChange(permissionKey, 'read', event.target.checked)}
                          disabled={!permissionSGU?.units?.write}
                          isValid
                        />
                      </Form.Check>
                    </td>
                    <td>
                      <Form.Check type="checkbox">
                        <Form.Check.Input
                          type="checkbox"
                          checked={!!user?.permissionSGU?.[permissionKey]?.write}
                          onChange={(event) => handlePermissionChange(permissionKey, 'write', event.target.checked)}
                          disabled={!permissionSGU?.units?.write}
                          isValid
                        />
                      </Form.Check>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <Button
              variant="success"
              onClick={() => { saveUser() }}
              disabled={!permissionSGU?.units?.write}
            >
              Salvar
            </Button>

          </Col>
        </Card.Body>
      </Card>
    </Page>
  );
};

export default UnitsMembersEdit;
